/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a constant, not a component. */
export const SCHEDULER_GRID_METRICS = {
  weekRowCount: 6,
  weekdayHeaderHeight: 44,
  rowMinHeight: 112,
  dayNumberHeight: 24,
  eventSlotHeight: 25,
  moreLineHeight: 20,
  minCapacity: 2,
} as const;
